module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/433e0c4ca6a9a38fffa19b3faf92fb59.gif";